import '@styles/app.pcss';
import main from '@commons/main';
import header from '@commons/header';
import SearchIndex from '@vue-instances/SearchIndex';

export default function init() {
  // Commons
  header();
  main();

  // Vue instances
  SearchIndex();
}

init();
